/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-triangle': {
    width: 800,
    height: 800,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#svgicon_alert-triangle_a)"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.827 2.229c.967-1.639 3.38-1.639 4.347 0l9.486 16.073c.998 1.691-.296 3.698-2.174 3.698H2.514C.636 22-.658 19.993.34 18.302L9.827 2.23zm.232 4.826A1 1 0 0111.057 6h1.886a1 1 0 01.998 1.055l-.389 7a1 1 0 01-.998.945h-1.108a1 1 0 01-.998-.944l-.39-7zM14 18a2 2 0 11-4 0 2 2 0 014 0z" _fill="#f04237"/></g><defs><clipPath id="svgicon_alert-triangle_a"><path pid="1" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
